export default prm

/** @ngInject */
function prm() {
    return function (val) {
        if (val) {
            return `${val.slice(0, 2)} ${val.slice(2, 5)} ${val.slice(5, 8)} ${val.slice(8, 11)} ${val.slice(11)}`
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/filters/prm.js